
import Page from '@root/common/base/Page';
import ListSkeletonLoader from '@root/common/components/base/loader/ListSkeletonLoader.vue';

import { QueryResult } from '@root/modules/headlines/types/headlines';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import HeadlineList from '@root/common/components/base/headline/HeadlineList.vue';
import PageHeader from '@root/common/components/base/PageHeader.vue';

import { getPageOffset } from '@root/common/utils/getPageOffset';

export default Page.extend({
  components: {
    HeadlineList,
    PageHeader,
    ListSkeletonLoader,
  },
  data() {
    return {
      latestHeadlines: {
        items: [],
        pager: {
          offset: 0,
          limit: 0,
        },
      } as QueryResult,
      headlineSettings: { lead: true, publishDate: false, author: false, titleComment: true },
    };
  },
  async fetch() {
    const limit = 50;
    const offset = getPageOffset(limit, this.$route.query.page);
    const { domain } = this.$channelConfig('settings');
    const { disallowedCategories = [] } = this.$channelConfig('page').latest.settings;
    const excludeCategories = disallowedCategories.map((i: string) => Number(i));
    const variables: { offset: number; limit: number; domain: string | string[]; excludeCategories: number | number[] } = {
      offset,
      limit,
      domain,
      excludeCategories,
    };

    try {
      const universalHeadlinesService = new UniversalHeadlinesService({ req: this.$ssrContext?.req });
      this.latestHeadlines = await universalHeadlinesService.fetch(variables);
    } catch (e) {
      this.handlePageError(e);
    }
  },
  mounted() {
    this.restoreScroll();
  },
  methods: {
    changePage() {
      this.$fetch();
    },
  },
  head() {
    const meta = this.getPageMeta();
    const title: string = this.$t('latest.title');
    meta.setTitle({ title });

    return {
      title: meta.title,
      meta: meta.data,
      link: meta.link,
    };
  },
});
